<template>
  <SlotBanner
    start="2024-11-15T08:00:00.000Z"
    finish="2024-12-09T07:59:00.000Z"
    @start="$emit('start')"
    @finish="$emit('finish')"
  >
    <div class="black-friday-banner">
      <div class="content">
        <span class="content_1">Black friday</span>
        <span class="content_center">
          <span class="content_2">Up to 3 extra licenses FOR FREE</span>
          <span class="content_3">
            <span class="plus">+</span> Special offer for TI LOOKUP
          </span>
        </span>
        <a target="_blank" href="https://app.any.run/plans"> Get it now </a>
      </div>
    </div>
  </SlotBanner>
</template>

<script>
import { defineComponent } from 'vue';

import SlotBanner from './SlotBanner.vue';

export default defineComponent({
  name: 'BlackFridayBanner',
  components: { SlotBanner },
});
</script>

<style lang="scss">
.black-friday-banner {
  font-family: 'Montserrat', sans-serif;
  height: 86px;
  background: #001626;
  position: relative;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  overflow: hidden;
  display: block;

  * {
    font-family: 'Montserrat', sans-serif;
  }
}

.black-friday-banner .close {
  display: none;
  position: absolute;
  width: 24px;
  height: 24px;
  overflow: hidden;
  top: 10px;
  right: 10px;
  opacity: 1;
  user-select: none;
}
.black-friday-banner .close:hover svg {
  fill: #fff;
  opacity: 1;
}
.black-friday-banner .close svg {
  display: block;
  opacity: 0.7;
}
.black-friday-banner .content {
  font-family: 'Montserrat', Arial, 'Helvetica Neue', Helvetica, sans-serif;
  color: #fff;
  max-width: 1023px;
  margin: 0 auto;
  height: 86px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.black-friday-banner .content::before {
  content: '';
  display: block;
  width: 620px;
  height: 86px;
  position: absolute;
  left: -520px;
  top: 0;
  z-index: 1;
  background: url('@/assets/images/blackFriday/black-friday-left.png') center
    center no-repeat;
  background-size: contain;
}
.black-friday-banner .content::after {
  content: '';
  display: block;
  width: 810px;
  height: 86px;
  position: absolute;
  right: -445px;
  top: 0;
  z-index: 1;
  background: url('@/assets/images/blackFriday/black-friday-right.png') center
    center no-repeat;
  background-size: contain;
}

.black-friday-banner .content .plus {
  font-size: 25px;
  line-height: 22px;
  position: relative;
  top: 2px;
}

.black-friday-banner .content .content_1 {
  font-weight: 900;
  font-size: 43px;
  line-height: 43px;
  color: #ffa221;
  text-transform: uppercase;
  z-index: 2;
  position: relative;
}

.black-friday-banner .content .content_2,
.black-friday-banner .content .content_3 {
  font-weight: 800;
  font-size: 20px;
  line-height: 22px;
  text-transform: uppercase;
  display: block;
  z-index: 2;
  position: relative;
}
.black-friday-banner .content .content_3 {
  color: #02c0fc;
}

.black-friday-banner .content a {
  display: block;
  border: none;
  border-radius: 3px;
  color: #001626;
  background-color: #ffa221;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  padding: 9px 42px;
  z-index: 2;
  position: relative;
  text-decoration: none;
}
.black-friday-banner .content a:hover {
  text-decoration: none;
  background: #ef8b00;
}

@media screen and (max-width: 1533px) {
  .black-friday-banner .content {
    margin-left: 255px;
  }
}

@media screen and (max-width: 1439px) {
  .black-friday-banner .content {
    max-width: 793px;
    margin-left: auto;
  }

  .black-friday-banner .content::before {
    left: -460px;
  }

  .black-friday-banner .content .content_1 {
    font-size: 30px;
    line-height: 30px;
  }

  .black-friday-banner .content .content_2,
  .black-friday-banner .content .content_3 {
    font-size: 18px;
    line-height: 18px;
  }

  .black-friday-banner .content .plus {
    font-size: 23px;
  }
}

@media screen and (max-width: 1100px) {
  .black-friday-banner .content {
    margin-left: 150px;
  }

  .black-friday-banner .content::after {
    right: -356px;
  }
}

@media screen and (max-width: 980px) {
  .black-friday-banner .content::after {
    display: none;
  }

  .black-friday-banner::after {
    content: '';
    display: block;
    width: 229px;
    height: 86px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    background: url('@/assets/images/blackFriday/black-friday-right-2.png')
      center center no-repeat;
    background-size: contain;
  }
}

@media screen and (max-width: 979px) {
  .black-friday-banner .content::before {
    display: none;
  }
  .black-friday-banner::before {
    content: '';
    display: block;
    width: 300px;
    height: 86px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    background: url('@/assets/images/blackFriday/black-friday-left.png') center
      center no-repeat;
    background-size: cover;
    background-position-x: -310px;
  }

  .black-friday-banner .content {
    max-width: 427px;
    margin-left: auto;
  }

  .black-friday-banner .content .content_1 {
    font-size: 20px;
    line-height: 22px;
    position: absolute;
    top: 15px;
    left: 0;
    letter-spacing: 0.03em;
  }

  .black-friday-banner .content .content_2,
  .black-friday-banner .content .content_3 {
    font-weight: 700;
    font-size: 13px;
    line-height: 24px;
    text-transform: none;
    letter-spacing: 0.02em;
    color: #fff;
  }
  .black-friday-banner .content .content_2 {
    position: relative;
    top: 3px;
  }
  .black-friday-banner .content .content_3 {
    position: relative;
    top: -4px;
  }

  .black-friday-banner .content_center {
    position: relative;
    top: 11px;
  }
  .black-friday-banner .content .plus {
    font-size: 18px;
    line-height: 16px;
    display: inline-block;
  }
}

@media screen and (max-width: 724px) {
  .black-friday-banner::before {
    width: 110px;
    background: url('@/assets/images/blackFriday/black-friday-left-2.png')
      center center no-repeat;
    background-size: cover;
    background-position-x: left;
  }
}

@media screen and (max-width: 520px) {
  .black-friday-banner::after {
    display: none;
  }

  .black-friday-banner .content {
    max-width: 100%;
    margin-left: 0;
    padding-left: 46px;
    padding-right: 13px;
    white-space: nowrap;
    gap: 8px;
  }

  .black-friday-banner .content .content_1 {
    font-size: 18px;
    line-height: 20px;
    top: 18px;
    left: 46px;
  }

  .black-friday-banner .content .content_2,
  .black-friday-banner .content .content_3 {
    font-size: 11px;
    letter-spacing: normal;
  }
  .black-friday-banner .content .content_2 {
    top: 4px;
  }
  .black-friday-banner .content .content_3 {
    top: -6px;
  }

  .black-friday-banner .content .plus {
    font-size: 16px;
    line-height: 11px;
    display: inline-block;
  }

  .black-friday-banner .content_center {
    top: 13px;
  }

  .black-friday-banner .content a {
    text-align: center;
    padding: 9px 0;
    width: 130px;
  }
}

@media screen and (max-width: 379px) {
  .black-friday-banner::before {
    display: none;
  }

  .black-friday-banner .content {
    padding: 0 10px;
    margin: 0 auto;
  }

  .black-friday-banner .content .content_1 {
    left: 10px;
  }
}
</style>
